module.exports = __webpack_public_path__ + "img/client7.af9cf215.png";